import React from "react";
import ErrorIcon from "@mui/icons-material/Error";
import {
  ErrorContainer,
  ErrorList,
  ErrorItem,
} from "./FormErrorContainer.styled";

interface FormErrorContainerProps {
  errors: string[];
  visible?: boolean;
  style?: React.CSSProperties;
}

const FormErrorContainer: React.FC<FormErrorContainerProps> = ({
  errors,
  visible = true,
  style,
}) => {
  if (!visible || !errors.length) {
    return null;
  }

  return (
    <ErrorContainer style={style}>
      <ErrorIcon sx={{ color: "#ffff" }} />
      <ErrorList>
        {errors.map((error, index) => (
          <ErrorItem key={index}>{error}</ErrorItem>
        ))}
      </ErrorList>
    </ErrorContainer>
  );
};

export default FormErrorContainer;
